import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import { MaskedLinesOnView, Reveal } from '../components/Reveal';
import { BLOG_POSTS } from '../data/blog';

export default function Blog() {
  return (
    <>
      <SEO
        title="Blog | Thula Doula Wellness — Humble, TX"
        description="Education from the table: prenatal massage, lymphatic drainage, deep tissue, VA Community Care, and postpartum recovery — written by the Thula team."
      />
      <PageHeader
        testId="blog-page-header"
        eyebrow="The Journal"
        lines={['Notes from', 'the table.']}
        sub="Education on the work we practice — prenatal care, lymphatic health, veteran services, and recovery."
      />

      <section className="bg-brand-cream pb-24 md:pb-32" data-testid="blog-listing">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
          <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
            {BLOG_POSTS.map((post, i) => (
              <Reveal key={post.slug} delay={(i % 3) * 0.1}>
                <Link
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-card-${post.slug}`}
                  className="group flex h-full flex-col"
                >
                  <div className="overflow-hidden rounded-2xl">
                    <img
                      src={post.cover}
                      alt={post.title}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                    />
                  </div>
                  <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-brand-teal">
                    {post.category} · {post.readTime}
                  </p>
                  <h2 className="mt-2 font-display text-2xl font-normal leading-snug tracking-tight text-brand-ink transition-colors duration-300 group-hover:text-brand-teal md:text-[27px]">
                    {post.title}
                  </h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-moss">{post.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-teal">
                    Read article
                    <ArrowUpRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>

          <div className="mt-20 rounded-3xl bg-brand-parchment p-8 text-center md:p-14" data-testid="blog-cta">
            <MaskedLinesOnView
              as="h2"
              lines={['Reading is step one.']}
              className="font-display text-3xl font-light italic tracking-tight text-brand-ink md:text-4xl"
            />
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-brand-moss md:text-base">
              When you’re ready, the table is warm and the kettle is on.
            </p>
            <div className="mt-8 flex justify-center">
              <a
                data-testid="blog-book-btn"
                href="https://thuladoulamassage.janeapp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2.5 rounded-full bg-brand-teal px-8 py-4 text-sm font-semibold text-brand-cream transition-[background-color,transform] duration-300 hover:bg-brand-ink active:scale-[0.97]"
              >
                Book a Massage
                <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
